<template>
<div class="page_result">
  <div class="wrapper">
    <h2>エネルギー消費性能計算結果</h2>
    <app-error-list/>
    
    <!-- エネルギー消費性能計算結果 -->
    <div class="ly_flex">
        <div class="table_wrapper">
            <h4>一次エネルギー消費量</h4>
            <table class="result_ene pattern_stripe">
                <thead>
                    <tr>
                        <th>内訳項目</th>
                        <th>設計一次</th>
                        <th class="standard">基準一次</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th>暖房設備</th>
                        <td>{{ result.e_H | addComma}}<span class="result_unit">MJ</span></td>
                        <td class="standard">{{ result.e_SH | addComma}}<span class="result_unit">MJ</span></td>
                    </tr>
                    <tr>
                        <th>冷房設備</th>
                        <td>{{ result.e_C| addComma}}<span class="result_unit">MJ</span></td>
                        <td class="standard">{{ result.e_SC | addComma}}<span class="result_unit">MJ</span></td>
                    </tr>
                    <tr>
                        <th>換気設備</th>
                        <td>{{ result.e_V | addComma}}<span class="result_unit">MJ</span></td>
                        <td class="standard">{{ result.e_SV | addComma}}<span class="result_unit">MJ</span></td>
                    </tr>
                    <tr>
                        <th>給湯設備</th>
                        <td>{{ result.e_W | addComma}}<span class="result_unit">MJ</span></td>
                        <td class="standard">{{ result.e_SW | addComma}}<span class="result_unit">MJ</span></td>
                    </tr>
                    <tr>
                        <th>照明設備</th>
                        <td>{{ result.e_L | addComma}}<span class="result_unit">MJ</span></td>
                        <td class="standard">{{ result.e_SL | addComma}}<span class="result_unit">MJ</span></td>
                    </tr>
                    <tr>
                        <th>その他の設備</th>
                        <td>{{ result.e_M | addComma}}<span class="result_unit">MJ</span></td>
                        <td class="standard">{{ result.e_SM | addComma}}<span class="result_unit">MJ</span></td>
                    </tr>
                    <tr class="sakugenryo">
                        <th>発電設備の発電量<br class="pc_only">のうち自家消費分</th>
                        <td>{{ result.e_S_h | addComma}}<span class="result_unit">MJ</span></td>
                        <td class="standard">--<span class="result_unit">MJ</span></td>
                    </tr>
                    <tr class="sakugenryo">
                        <th>コージェネレーション設備の<br class="pc_only">売電量に係る控除量</th>
                        <td>{{ result.e_S_sell | addComma}}<span class="result_unit">MJ</span></td>
                        <td class="standard">--<span class="result_unit">MJ</span></td>
                    </tr>
                    <tr class="goukei">
                        <th>合計</th>
                        <td>{{ result.e_T | addComma}}<span class="result_unit">MJ</span></td>
                        <td class="standard">{{ result.e_ST | addComma}}<span class="result_unit">MJ</span></td>
                    </tr>
                </tbody>
            </table>
            
            <!-- 外皮性能 -->
            <h4>外皮性能</h4>
            <table class="table_second uq_envelope">
                <tbody>
                    <tr class="direction_row">
                        <th colspan="2">外皮平均熱貫流率</th>
                        <td>{{ result.u_A | addComma}}<span class="result_unit">W/m<sup>2</sup>K</span></td>
                    </tr>
                    <tr class="direction_row">
                        <th colspan="2">冷房期平均日射熱取得率</th>
                        <td>{{ result.etA_AC | addComma}}<span class="result_unit"></span></td>
                    </tr>
                    <tr class="direction_row">
                        <th colspan="2">暖房期平均日射熱取得率</th>
                        <td>{{ result.etA_AH | addComma}}<span class="result_unit"></span></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="table_wrapper">
        <!-- 判定結果 -->
            <h4 v-if="bsc_type == 1 || bsc_type == 2">判定結果</h4>
            <!-- 住宅版 -->
            <table v-if="bsc_type == 1" class="table_evaluation">
                <thead>
                    <tr>
                        <th colspan="2" rowspan="2">適用する基準</th>
                        <th colspan="2">一次エネルギー消費量<span class="str_small">(戸・年)</span></th>
                        <th rowspan="2" class="result_evaluation">結果</th>
                    </tr>
                    <tr>
                        <th>設計一次</th>
                        <th>基準一次</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th rowspan="4">建築物省エネ法</th>
                        <td>建築物エネルギー<br class="pc_only" />消費性能基準<br />（H28年4月以降）</td>
                        <td rowspan="5" class="result_calclated">{{ result.e_T_GJ }}<span class="result_unit">GJ</span></td>
                        <td class="standard">{{ result.e_ST_GJ_gn_p | addComma}}<span class="result_unit">GJ</span></td>
                        <td class="result_evaluation">{{ result.statuS_gn_p | addComma}}</td>
                    </tr>
                    <tr>
                        <td>建築物エネルギー<br class="pc_only" />消費性能基準<br />（H28年4月現存）</td>
                        <td class="standard">{{ result.e_ST_GJ_gn_e | addComma}}<span class="result_unit">GJ</span></td>
                        <td class="result_evaluation">{{ result.statuS_gn_e | addComma}}</td>
                    </tr>
                    <tr>
                        <td>建築物エネルギー<br class="pc_only" />消費性能誘導基準<br />（H28年4月以降）</td>
                        <td class="standard">{{ result.e_ST_GJ_indc_p | addComma}}<span class="result_unit">GJ</span></td>
                        <td class="result_evaluation">{{ result.statuS_indc_p | addComma}}</td>
                    </tr>
                    <tr>
                        <td>建築物エネルギー<br class="pc_only" />消費性能誘導基準<br />（H28年4月現存）</td>
                        <td class="standard">{{ result.e_ST_GJ_indc_e | addComma}}<span class="result_unit">GJ</span></td>
                        <td class="result_evaluation">{{ result.statuS_indc_e | addComma}}</td>
                    </tr>
                    <tr>
                        <th>エコまち法</th>
                        <td>低炭素建物に<br class="pc_only" />関する認定基準</td>
                        <td class="standard">{{ result.e_ST_GJ_EnergyUseOfBuilding | addComma}}<span class="result_unit">GJ</span></td>
                        <td class="result_evaluation">{{ result.statuS_EnergyUseOfBuilding | addComma}}</td>
                    </tr>
                </tbody>
            </table>
            <!-- 気候風土適応住宅版 -->
            <table v-if="bsc_type == 2" class="table_evaluation">
                <thead>
                    <tr>
                        <th rowspan="2">適用する基準</th>
                        <th colspan="2">一次エネルギー消費量<span class="str_small">(戸・年)</span></th>
                        <th rowspan="2" class="result_evaluation">結果</th>
                    </tr>
                    <tr>
                        <th>設計一次</th>
                        <th>基準一次</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>建築物エネルギー消費性能基準<br />（気候風土適応住宅H28年4月以降）</td>
                        <td rowspan="5" class="result_calclated">{{ result.e_T_GJ | addComma}}<span class="result_unit">GJ</span></td>
                        <td class="standard">{{ result.e_ST_GJ_trad_p | addComma}}<span class="result_unit">GJ</span></td>
                        <td class="result_evaluation">{{ result.statuS_trad_p | addComma}}</td>
                    </tr>
                    <tr>
                        <td>建築物エネルギー消費性能基準<br />（気候風土適応住宅H28年4月現存）</td>
                        <td class="standard">{{ result.e_ST_GJ_trad_e | addComma}}<span class="result_unit">GJ</span></td>
                        <td class="result_evaluation">{{ result.statuS_trad_e | addComma}}</td>
                    </tr>
                </tbody>
            </table>
    
        <!-- BEI -->
            <h4>BEI</h4>
            <table class="table_bei">
                <thead>
                    <tr>
                        <th colspan="2">一次エネルギー消費量（その他の設備を除く）</th>
                        <th rowspan="2">BEI</th>
                    </tr>
                    <tr>
                        <th>設計一次</th>
                        <th>基準一次</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ result.e_T_GJ_WO | addComma}}<span class="result_unit">GJ</span></td>
                        <td>{{ result.e_ST_GJ_WO | addComma}}<span class="result_unit">GJ</span></td>
                        <td>{{ result.bei }}</td>
                    </tr>
                </tbody>
            </table>
        </div> 
        <hr class="w100">
        <!-- 参考値 -->
        <div class="table_wrapper">
            <h4>設計二次エネルギー消費量等（参考値）</h4>
            <table class="table_second">
                <tbody>
                    <tr class="direction_row">
                        <th rowspan="3">設計二次エネルギー消費量</th>
                        <th>消費電力量</th>
                        <td>{{ result.sE_E | addComma}}<span class="result_unit">kWh</span></td>
                    </tr>
                    <tr class="direction_row">
                        <th>ガス消費量</th>
                        <td>{{ result.sE_G | addComma}}<span class="result_unit">MJ</span></td>
                    </tr>
                    <tr class="direction_row">
                        <th>灯油消費量</th>
                        <td>{{ result.sE_O | addComma}}<span class="result_unit">MJ</span></td>
                    </tr>
                    <tr class="direction_row">
                        <th colspan="2">コージェネレーション設備の<br>売電量に係るガス消費量の控除量</th>
                        <td>{{ result.sE_G_CG_for_sell | addComma}}<span class="result_unit">MJ</span></td>
                    </tr>
                    <tr class="direction_row">
                        <th colspan="2">未処理負荷の設計一次エネルギー消費量相当値</th>
                        <td>{{ result.upl | addComma}}<span class="result_unit">MJ</span></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="table_wrapper">
            <h4>発電量・売電量（参考値）<span>一次エネルギー換算した値</span></h4>
            <table>
                <thead>
                    <tr>
                        <th>設備の種類</th>
                        <th>発電量</th>
                        <th>売電量</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="direction_row">
                        <th>コージェネレーション</th>
                        <td>{{ result.e_CG_gen | addComma}}<span class="result_unit">MJ</span></td>
                        <td>{{ result.e_CG_sell | addComma}}<span class="result_unit">MJ</span></td>
                    </tr>
                    <tr class="direction_row">
                        <th>太陽光発電</th>
                        <td>{{ result.e_PV_gen | addComma}}<span class="result_unit">MJ</span></td>
                        <td>{{ result.e_PV_sell | addComma}}<span class="result_unit">MJ</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <app-button
            value="PDFを出力する"
            @button-click="pdf"
            this-class="align_center"
            class="uq_btnPdf"
        />
        <div id="invisible"></div>

        <!-- 内容ここまで -->
    </div>
  </div>
</div>
</template>

<script>
/**
 * 計算結果画面
 * 
 * [算出プロパティ]
 * result ... 計算結果
 * errorList ... エラーの配列
 * 
 * [イベント処理]
 * PDF出力ボタン押下時 ... PDF出力
 */
import pdfMixin from '@/mixins/pdf'
import { mapGetters } from 'vuex'
import { mapComputedProperties } from '@/util'

export default {
    name:"Result",
    mixins:[pdfMixin],
    computed:{
        ...mapGetters({
            /**
             * 計算結果
             */
            result:'result/getResult',
            /**
             * エラーの配列
             */
            errorList:'error/getError',
        }),
        ...mapComputedProperties([
            'bsc_type',
            ]),
    },
    methods:{
        /**
         * PDFを出力する
         */
        pdf(){
            this.exportPdf()
        }
    },
    filters: {
        addComma: function (value) {
            if (!value.toString().match(/^\d+$/)) {
              return value;
            }
            let formatter = new Intl.NumberFormat('ja-JP');
            return formatter.format(value);
        }
    },
}
</script>

<style scoped>
.page_result .wrapper{
    padding-bottom: 300px;
}
.ly_flex{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 920px;
    margin: 0 auto;
    padding: 0 20px;
}
hr.w100{
    display: block;
    width: 100%;
    border: none;
    border-bottom: #1C4373 solid 1px;
}
.table_wrapper{
    display: block;
    box-sizing: border-box;
    min-width: 350px;
    width: 47%;
    max-width: 700px;
    margin: 0 auto 64px;
}
.table_wrapper h4{ 
    display: flex;
    width: 100%;
    font-size: 16px;
    margin: 16px 0 4px;
}
.table_wrapper span{
    display:inline-block;
    margin-left: auto;
    font-weight: 500;
    font-size: 14px;
}
.table_wrapper table{
    width: 100%;
    text-align: center;
    color:#1C4373;
    border: 3px solid #41B8D4;
    border-collapse: separate;
    border-spacing: 0; 
    border-radius: 5px;
}
.table_wrapper table thead th{
    padding: 8px;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.1em;
    background-color: #DCF4FF;
}
.table_wrapper thead tr:first-of-type th:first-child{
    border-top-left-radius: 3px;
}
.table_wrapper thead tr:first-of-type th:last-child{
    border-top-right-radius: 3px;
}
.table_wrapper tbody tr:last-of-type th:first-child,
.table_wrapper tbody tr:last-of-type td:first-child{
    border-bottom-left-radius: 3px;
}
.table_wrapper tbody tr:last-of-type th:last-child,
.table_wrapper tbody tr:last-of-type td:last-child{
    border-bottom-right-radius: 3px;
}
.table_wrapper table tbody th{
    padding: 8px 16px;
    background-color: white;
    border-bottom: 1px solid #93e0f3;
}
.table_wrapper table tbody tr:last-child th:last-child{
    border-bottom: none;
}
.table_wrapper table tbody td{
    padding: 3px 8px;
    font-size: 20px;
    background-color: white;
    border-bottom: 1px solid #93e0f3;
}
.table_wrapper table tbody tr:last-child th,
.table_wrapper table tbody tr:last-child td,
.table_wrapper table tbody tr th[rowspan]:nth-last-of-type(){
    border-bottom: none;
}
.table_wrapper .pattern_stripe tr th,
.table_wrapper .pattern_stripe tr td{
    padding: 6px 8px;
    border-bottom-color: #ddd;
}
.table_wrapper .pattern_stripe tr:nth-child(even) th,
.table_wrapper .pattern_stripe tr:nth-child(even) td{
    background-color: #f7f7f7;
}
.table_wrapper table th{
    font-size: 12px;
}
.table_wrapper table .str_small{
    margin-left: 4px;
    font-size: 10px;
    letter-spacing: -0.1em;
}
.table_wrapper table tbody .sakugenryo th,
.table_wrapper table tbody .sakugenryo td{
    color: #777;
}

.table_wrapper table tbody .sakugenryo th{
    min-width: 12em;
    font-size: 0.8em;
    line-height: 1.2;
}
.table_wrapper table tbody .goukei th,
.table_wrapper table tbody .goukei td{
    background-color:#DCF4FF;
    font-weight: bolder;
    border-bottom: none;
}
.table_wrapper table tbody .goukei td{
    padding: 12px 0;
    font-size: 24px;
}
.table_wrapper .result_unit{
    padding-left: 4px;
    font-size: 0.5em;
    line-height: 1;
    font-weight: bolder;
}

.table_wrapper table.result_ene tbody tr th{
    max-width: 10em;
}
.table_wrapper table.result_ene tbody td{
    text-align: right; 
    padding-right: 20px;
}
.table_wrapper table.result_ene tbody .goukei td{
    text-align: center; 
    padding-right: 0;
}
/* 判定結果 */
.table_wrapper .table_evaluation tr th,
.table_wrapper .table_evaluation tr td,
.table_wrapper .table_bei tr th,
.table_wrapper .table_bei tr td{
    border-top: 1px solid #93e0f3;
    border-bottom: none;
    border-left: 1px solid #93e0f3;
}
.table_wrapper .table_bei tr:first-of-type th{
    border-top: none;
}
.table_wrapper .table_evaluation tr:first-child th:first-child,
.table_wrapper .table_bei tr:first-child th:first-child,
.table_wrapper .table_bei tr td:first-child{
    border-left: none;
}

.table_wrapper .table_bei thead tr:not(:first-child) th{
    padding: 4px;
}
.table_wrapper .table_evaluation tr th{
    width: 18px;
    font-size: 13px;
    line-height: 13px;
    padding: 4px;
    letter-spacing: 0;
}
.table_wrapper .table_evaluation tbody td{
    padding: 12px 4px;
    min-width: 5em;
    max-width: 12em;
    font-size: 13px;
    line-height: 15px;
    font-weight: 600;
}
.table_wrapper .table_evaluation .result_calclated,
.table_wrapper .table_evaluation .standard{
    font-size: 18px;
    line-height: 18px;
    padding: 8px;
    text-align: right;
    font-weight: 500;
}

.table_wrapper .table_evaluation td.result_title{
    padding-bottom: 0;
    font-size: 14px;
    font-weight: bolder;
}
.table_wrapper .table_evaluation tr.result_calculated td .result_title{
    margin-right: 8px;
    font-size: 14px;
    font-weight: bolder;
}
.table_wrapper .table_evaluation td.result_evaluation{
    min-width: 3em; 
    padding: 4px 8px;
    font-size: 12px;
    font-weight: bolder;
}
.table_wrapper th.standard,
.table_wrapper td.standard{
    color: #5f5f5f;
}
.table_wrapper tr.bei_goukei td,
.table_wrapper tr.bei_goukei th{
    border-top: 1.5px solid #54cbe6;
}
.table_wrapper tbody tr.bei_goukei th{
    background-color:#DCF4FF;
}
.table_wrapper tbody .direction_row th{
    background-color:rgb(242, 251, 255);
    border-bottom-color: #93e0f3
}
.table_wrapper tbody .direction_row th[rowspan],
.table_wrapper tbody .direction_row th[colspan]{
    background-color: #DCF4FF;
    border-bottom-color: #54cbe6;
    padding: 8px 12px;
}
.table_wrapper tbody .direction_row td{
    background-color: white;
}
.table_wrapper .table_bei thead tr:nth-child(2) th:first-child{
    border-left: none;
}

.table_wrapper .table_second td{
    text-align: right;
}
.table_wrapper .table_second tbody tr:first-child th:first-child{
    border-top-left-radius: 3px;
}
.table_wrapper .table_second tbody tr:first-child td:last-child{
    border-top-right-radius: 3px;
}
.table_wrapper .table_second tbody tr:last-child th:first-child{
    border-bottom-left-radius: 3px;
    border-bottom: none;
} 
.table_wrapper .table_second tbody tr:last-child td:last-child{
    border-bottom-right-radius: 3px;
    border-bottom: none;
} 
.table_wrapper .table_second .result_unit{
    width: 3em;
    text-align: left;
}
.table_wrapper .uq_envelope .result_unit{
    width: 5em;
}


.ly_flex{
    justify-content: flex-start;
    width: 900px;
    margin: 0 auto;
}

input.uq_btnPdf{
    padding: 8px 50px;
    font-size: 18px;
    background: linear-gradient(#6dc7dd, #41b8d4);
    border-radius: 8px;
}
input.uq_btnPdf:hover{
    background: linear-gradient(#41b8d4, #6dc7dd);
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.3);
}

/* レスポンシブ（タブレット縦よりウインドウ幅が狭いもの） */
@media screen and (max-width: 1000px) {
    .table_wrapper,
    .table_wrapper.w100{
        min-width: 350px;
        width: 100%;
        margin-bottom: 16px;
    }
    .table_wrapper table.result_ene tbody th{
        min-width: 10em;
        max-width: 20vw;
        white-space: pre-wrap;
    }
    .table_wrapper table.result_ene tbody td:not(:first-child){
        text-align: right; 
        padding-right: calc(12% - 2rem);
    }
        
    .table_wrapper .table_evaluation .result_calclated,
    .table_wrapper .table_evaluation .standard{
        text-align: right; 
        padding-top: 8px;
        padding-bottom: 8px;
    }
    br.pc_only{
        display: none;
    }
    .table_wrapper .table_evaluation tr td:first-child{
        min-width: 30%;
    }
}
</style>

